import { useTranslation } from "react-i18next";
import { useGethowitworks } from "./HomepageApi";
import React from "react";

import moment from 'moment/moment';
import LanguageContext from "../languageContext/LanguageContext";
import { useContext } from "react";
import { Portal } from "@mui/material";
import {WhatsappShareButton} from "react-share";
const HowItWorks = (props) => {   
    const { t } = useTranslation();
    const {language} = useContext(LanguageContext)


    const getTitle = (rowdata) => {
        switch (language) {
            case 'french':
                return rowdata.Frenchtitle;
            case 'Portuguese':
                return rowdata.Portugaltitle;
            default:
                return rowdata.englishtitle;
        }
    };
    
    

    const { data: Howitworks } = useGethowitworks();
    console.log("🦁 ~ HowItWorks ~ Howitworks:", Howitworks?.data);
   
    
    return (            
        <div className="MainBg">
            <div className="CntLdDv">
                <div className="HIWSec">
                    <div className="container">
                        <div className="HIWDv">
                            <h3>{t('How it works')}</h3>
                            <p>{t('Owning a kkog token coin will help you gain many benefits in the future.')}</p>
                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <div className="row HIWDts">
                                        {Howitworks?.data.map((rowdata, index) => (
                                            <React.Fragment key={index}>
                                                <div className="col-lg-4">
                                                    <div className="HIWDtsL">
                                                        <div>

                                                        <h4>{getTitle(rowdata)}</h4>
                                                        {/* setValue('releasedate', moment(rowdata.releasedate).format('YYYY-MM-DDTHH:mm') || '') */}
                                                        <h6>Release Date:<br/> { moment(rowdata.releasedate).format('DD.MM.YYYY')}</h6>
                                                        </div>
                                                        <WhatsappShareButton url={rowdata.videourl}>
                                                            <span className="Wbndskj">
share it
</span>
 </WhatsappShareButton>
                                                    </div>
                                                  
                                                </div>

                                                <div className="col-lg-8">
                                                    <video width="100%" height="350" controls>
                                                        <track default kind="captions" src={rowdata.captionSrc} />
                                                        <source src={rowdata.videourl} type="video/mp4" />
                                                    </video>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HowItWorks;
